module.exports = __webpack_public_path__ + "img/nav-comentario.dd1c6d4d.svg";